import * as React from "react";
import { Avatar } from "@material-ui/core";
import { observer } from "mobx-react";
import { StyleSheet, css } from "aphrodite";
import { RateLibrary } from "modules/rateLibrary/models/RateLibrary";

const styles = StyleSheet.create({
  avatar: {
    margin: 10,
    width: 34,
    height: 34,
    fontSize: "1rem",
  },
});

type IProps = {
  lib: RateLibrary;
};

@observer
class RateLibraryAvatar extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  getAvatarAbreviation(): string {
    var nameSplit = String(this.props.lib.ownerName).toUpperCase().split(" ");
    var initials = "";
    if (nameSplit.length == 1) {
      initials = nameSplit[0] ? nameSplit[0].charAt(0) : "?";
    } else {
      initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
    }
    return initials;
  }

  render() {
    if (this.props.lib.ownerPhoto && this.props.lib.ownerPhoto !== "") {
      return (
        <Avatar
          alt={this.props.lib.ownerName}
          src={this.props.lib.ownerPhoto}
          className={css(styles.avatar)}
        />
      );
    } else {
      return (
        <Avatar
          alt={this.props.lib.ownerName}
          className={css(styles.avatar)}
          style={{ backgroundColor: "#ABC200" }}
        >
          {this.getAvatarAbreviation()}
        </Avatar>
      );
    }
  }
}

export default RateLibraryAvatar;



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/RateLibraryAvatar.tsx